import { useLocation } from 'react-router-dom';
import useSeo from './useSeo';
import SeoHelmet from './SeoHelmet';
import {useMemo} from "react";

export default function SeoLoader() {
    const location = useLocation();

    const seoPath = useMemo(() => {
        return location.pathname + location.search;
    }, [
        location.pathname,
        location.search
    ]);

    const { seo } = useSeo(seoPath);


    if (!seo) {
        return null;
    }

    return (
        <SeoHelmet seo={seo}/>
    );
}